module.exports = __webpack_public_path__ + "static/media/logoSmall.a657f225.png";